import React from 'react';
import { Alert, Card, Statistic, Row, Col } from 'antd';
import {
    CheckCircleOutlined,
    WarningOutlined,
    InfoCircleOutlined,
} from '@ant-design/icons';

const TIPO_ALERT = {
    positivo: { type: 'success', icon: <CheckCircleOutlined /> },
    atencao: { type: 'warning', icon: <WarningOutlined /> },
    empate: { type: 'info', icon: <InfoCircleOutlined /> },
    negativo: { type: 'error', icon: <WarningOutlined /> },
};

/**
 * Bloco de resultado padrão dos simuladores.
 * veredicto: { tipo, titulo, detalhe }
 * stats: [{ title, value }]
 */
function SimuladorResultado({ veredicto, stats = [], children }) {
    if (!veredicto) return null;

    const alertCfg = TIPO_ALERT[veredicto.tipo] || TIPO_ALERT.empate;

    return (
        <div className="simulador-resultado">
            <Alert
                type={alertCfg.type}
                showIcon
                icon={alertCfg.icon}
                message={veredicto.titulo}
                description={veredicto.detalhe}
                style={{ marginBottom: 16 }}
            />
            {stats.length > 0 && (
                <Card size="small" className="simulador-resultado-stats">
                    <Row gutter={[16, 16]}>
                        {stats.map((s) => (
                            <Col xs={12} sm={8} key={s.title}>
                                <Statistic title={s.title} value={s.value} valueStyle={{ fontSize: 18 }} />
                            </Col>
                        ))}
                    </Row>
                </Card>
            )}
            {children}
        </div>
    );
}

export default SimuladorResultado;
